export const userAuth='userAuth'
export const doctorAuth='doctorAuth'
export const adminAuth='adminAuth'
export const refreshToken = 'refreshToken';
